/**
 * @generated SignedSource<<73686e4026e05275438d601afda9a52c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IntegrationProvider = "ASANA" | "CLICKUP" | "HUBSPOT_TASK" | "JIRA" | "LINEAR" | "MICROSOFT_TODO" | "MONDAY" | "TRELLO";
export type ActionItemIntegrationsConnectStreamMutation$variables = {
  destinationInfo: any;
  integrationProvider: IntegrationProvider;
  streamId: string;
};
export type ActionItemIntegrationsConnectStreamMutation$data = {
  readonly connectStreamToIntegration: {
    readonly stream: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ActionItemIntegrationsStreamIntegration">;
    } | null;
  } | null;
};
export type ActionItemIntegrationsConnectStreamMutation = {
  response: ActionItemIntegrationsConnectStreamMutation$data;
  variables: ActionItemIntegrationsConnectStreamMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "destinationInfo"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "integrationProvider"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "streamId"
},
v3 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "destinationInfo",
        "variableName": "destinationInfo"
      },
      {
        "kind": "Variable",
        "name": "integrationProvider",
        "variableName": "integrationProvider"
      },
      {
        "kind": "Variable",
        "name": "streamId",
        "variableName": "streamId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  },
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = [
  (v4/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "includeAiGenerated",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalListId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalBoardId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalBoardName",
  "storageKey": null
},
v12 = [
  (v6/*: any*/),
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ActionItemIntegrationsConnectStreamMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ConnectStreamToIntegrationPayload",
        "kind": "LinkedField",
        "name": "connectStreamToIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ActionItemIntegrationsStreamIntegration"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ActionItemIntegrationsConnectStreamMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ConnectStreamToIntegrationPayload",
        "kind": "LinkedField",
        "name": "connectStreamToIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StreamActionItemIntegrationNode",
                "kind": "LinkedField",
                "name": "actionItemIntegration",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "integrationProvider",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "integrationSpecificDetails",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ClickupUserNode",
                            "kind": "LinkedField",
                            "name": "clickupUser",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "externalListName",
                            "storageKey": null
                          },
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "externalWorkspaceId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "externalSpaceId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "externalFolderId",
                            "storageKey": null
                          }
                        ],
                        "type": "ClickupStreamIntegrationNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TrelloUserNode",
                            "kind": "LinkedField",
                            "name": "trelloUser",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": null
                          },
                          (v8/*: any*/),
                          (v10/*: any*/),
                          (v9/*: any*/),
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "uncheckedListId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "doneListId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "organizationId",
                            "storageKey": null
                          }
                        ],
                        "type": "TrelloStreamIntegrationNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MondayUserNode",
                            "kind": "LinkedField",
                            "name": "mondayUser",
                            "plural": false,
                            "selections": (v12/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "externalGroupName",
                            "storageKey": null
                          },
                          (v8/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "externalGroupId",
                            "storageKey": null
                          },
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "assigneeColumnId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "statusColumnId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dueDateColumnId",
                            "storageKey": null
                          }
                        ],
                        "type": "MondayStreamIntegrationNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LinearUserNode",
                            "kind": "LinkedField",
                            "name": "linearUser",
                            "plural": false,
                            "selections": (v12/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "teamName",
                            "storageKey": null
                          },
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "teamId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "projectId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cycleId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "statusId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "uncheckedStatusId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "doneStatusId",
                            "storageKey": null
                          }
                        ],
                        "type": "LinearStreamIntegrationNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AsanaStreamNode",
                "kind": "LinkedField",
                "name": "asanaStream",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AsanaProjectNode",
                    "kind": "LinkedField",
                    "name": "asanaProject",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "externalId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "workspaceExternalId",
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d8142c6e341f889baf22cea20f6519ff",
    "id": null,
    "metadata": {},
    "name": "ActionItemIntegrationsConnectStreamMutation",
    "operationKind": "mutation",
    "text": "mutation ActionItemIntegrationsConnectStreamMutation(\n  $integrationProvider: IntegrationProvider!\n  $destinationInfo: JSON!\n  $streamId: String!\n) {\n  connectStreamToIntegration(input: {integrationProvider: $integrationProvider, destinationInfo: $destinationInfo, streamId: $streamId}) {\n    stream {\n      id\n      ...ActionItemIntegrationsStreamIntegration\n    }\n  }\n}\n\nfragment ActionItemIntegrationsStreamIntegration on NoteStream {\n  actionItemIntegration {\n    id\n    integrationProvider\n    integrationSpecificDetails {\n      __typename\n      ...clickupStreamDetails\n      ...trelloStreamDetails\n      ...mondayStreamDetails\n      ...linearStreamDetails\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  asanaStream {\n    ...asanaStreamDetails\n    id\n  }\n}\n\nfragment asanaStreamDetails on AsanaStreamNode {\n  asanaProject {\n    name\n    type\n    externalId\n    workspaceExternalId\n    id\n  }\n  createdBy {\n    fullName\n    id\n  }\n  includeAiGenerated\n}\n\nfragment clickupStreamDetails on ClickupStreamIntegrationNode {\n  clickupUser {\n    id\n    user {\n      fullName\n      id\n    }\n  }\n  externalListName\n  includeAiGenerated\n  externalListId\n  externalWorkspaceId\n  externalSpaceId\n  externalFolderId\n}\n\nfragment linearStreamDetails on LinearStreamIntegrationNode {\n  linearUser {\n    user {\n      fullName\n      id\n    }\n    id\n  }\n  teamName\n  includeAiGenerated\n  teamId\n  projectId\n  cycleId\n  statusId\n  uncheckedStatusId\n  doneStatusId\n}\n\nfragment mondayStreamDetails on MondayStreamIntegrationNode {\n  mondayUser {\n    user {\n      fullName\n      id\n    }\n    id\n  }\n  externalGroupName\n  includeAiGenerated\n  externalBoardId\n  externalGroupId\n  externalBoardName\n  assigneeColumnId\n  statusColumnId\n  dueDateColumnId\n}\n\nfragment trelloStreamDetails on TrelloStreamIntegrationNode {\n  trelloUser {\n    id\n    user {\n      fullName\n      id\n    }\n  }\n  includeAiGenerated\n  externalBoardId\n  externalListId\n  externalBoardName\n  uncheckedListId\n  doneListId\n  organizationId\n}\n"
  }
};
})();

(node as any).hash = "f37a3d615daac10a60812c9d8bc9ab41";

export default node;
